import { render, staticRenderFns } from "./FollowRecord.vue?vue&type=template&id=57ec2259&scoped=true"
import script from "./FollowRecord.vue?vue&type=script&lang=js"
export * from "./FollowRecord.vue?vue&type=script&lang=js"
import style0 from "./FollowRecord.vue?vue&type=style&index=0&id=57ec2259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec2259",
  null
  
)

export default component.exports